import { useMemo } from 'react';
import { FileEdit, AlertCircle, XCircle, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useConsignmentActions } from '@/features/consignment-actions';
import type { SelectionAction } from '@/shared/ui';

interface UseConsignmentSelectionProps {
  selectedIds: string[];
  onClearSelection?: () => void;
}

export function useConsignmentSelection({ selectedIds, onClearSelection }: UseConsignmentSelectionProps) {
  const { t } = useTranslation();
  const { actions, dialogs } = useConsignmentActions({
    selectedIds,
    onClearSelection
  });

  const selectionActions: SelectionAction[] = useMemo(
    () => [
      {
        id: 'edit',
        label: t('listaction.RQ.EDT'),
        icon: <FileEdit className="h-4 w-4" />,
        onClick: () => actions.editView(selectedIds),
        variant: 'default'
      },
      {
        id: 'priority',
        label: t('listaction.RQ.PRT'),
        icon: <AlertCircle className="h-4 w-4" />,
        onClick: () => actions.changePriority(selectedIds),
        variant: 'default'
      },
      {
        id: 'hold',
        label: t('listaction.RQ.HOL'),
        icon: <Clock className="h-4 w-4" />,
        onClick: () => actions.placeOnHold(selectedIds),
        variant: 'default'
      },
      {
        id: 'cancel',
        label: t('listaction.RQ.CAN'),
        icon: <XCircle className="h-4 w-4" />,
        onClick: () => actions.cancel(selectedIds),
        variant: 'destructive'
      }
    ],
    [actions, selectedIds, t]
  );

  return {
    selectedCount: selectedIds.length,
    selectionActions,
    dialogs,
    isVisible: selectedIds.length > 0
  };
}
